<template>
  <div v-if="page_loading">
    <loading :page_loading="page_loading" />
  </div>
  <div v-else>
    <loading :loading="loading" />

    <!-- นำทาง -->
    <v-card class="v-card-bottom-30">
      <v-card-title>
        {{ use_language.oms }}
        <v-icon>mdi-chevron-right</v-icon>
        {{ use_language.store }}
      </v-card-title>
    </v-card>

    <oms-import-dialog
      v-model="importDialog"
      :title="use_language.import_excel + ' : ' + use_language.store"
      :hint="use_language.import_hint_store"
      :columns="importColumns"
      :template-rows="importTemplateRows"
      template-name="oms_store_template"
      :import-fn="importStoreInChunks"
      @done="search()"
    />

    <!-- popup เพิ่ม/แก้ไขร้านค้า -->
    <v-dialog v-model="dialog" scrollable max-width="640" persistent :fullscreen="$vuetify.breakpoint.xsOnly">
      <v-card elevation="1">
        <v-card-title class="height-57">
          <span v-if="store.shopCustomerId == 0">{{ use_language.add_store }}</span>
          <span v-else>{{ use_language.edit_store }}</span>
          <v-spacer/>
          <v-btn icon @click="dialog = false"><v-icon color="danger">mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider/>
        <v-card-text class="overflow-x-auto">
          <v-form ref="storeForm" lazy-validation>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.location }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-autocomplete
                  v-model="store.locationId"
                  :items="locations"
                  :item-text="item => item.channel + ' : ' + item.name"
                  item-value="id"
                  :rules="rulesRequired"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.store_code }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="store.storeCode" @change="value => store.storeCode = Trim_value(value)" autocomplete="off" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.store_name }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="store.storeName" @change="value => store.storeName = Trim_value(value)" :rules="rulesRequired" autocomplete="off" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.contact }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="store.contactName" @change="value => store.contactName = Trim_value(value)" autocomplete="off" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.phone }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="store.phone" @change="value => store.phone = Trim_value(value)" :rules="rulesPhone" maxlength="12" autocomplete="off" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.address }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-text-field :value="store.address" @change="value => store.address = Trim_value(value)" :rules="rulesRequired" autocomplete="off" outlined dense></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" md="3" class="pa-0">{{ use_language.zipcode }} :</v-col>
              <v-col cols="12" md="9" class="pa-0">
                <v-autocomplete
                  v-model="store.postcodeMappingId"
                  :items="postcodeMapping"
                  :item-text="item => item.Postcode + ' ' + item.Province + ' ' + item.District + ' ' + item.SubDistrict"
                  item-value="Id"
                  :placeholder="use_language.zipcode_hint"
                  :rules="rulesRequired"
                  outlined
                  dense
                ></v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" class="pa-0" align="right">
                <v-btn :elevation="1" color="primary" class="px-2" @click="Save()">
                  <v-icon size="20" class="mr-1">mdi-content-save</v-icon>
                  <span class="fn-14"><b> {{ use_language.record }} </b></span>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-card elevation="1" class="v-card-bottom-30">
      <v-card-title class="height-57">
        <v-icon size="22" color="success darken-3">mdi-storefront</v-icon><span class="ml-3">{{ use_language.store }}</span>
        <v-spacer/>
        <v-btn :elevation="1" outlined color="success" class="px-2 mr-2" @click="importDialog = true">
          <v-icon size="20" class="mr-1">mdi-file-excel</v-icon>
          {{ use_language.import_excel }}
        </v-btn>
        <v-btn :elevation="1" color="primary" class="px-2" @click="Edit(null)">
          <v-icon size="22" class="mr-1">mdi-plus</v-icon>
          {{ use_language.add_store }}
        </v-btn>
      </v-card-title>
      <v-divider/>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="2" class="pa-1">
            <v-select v-model="filter.channel" :items="channelItems" :label="use_language.channel" outlined dense hide-details @change="onChannelChange()"></v-select>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-autocomplete
              v-model="filter.locationId"
              :items="locationItems"
              :label="use_language.location"
              outlined
              dense
              hide-details
              @change="search()"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="4" class="pa-1">
            <v-text-field
              v-model="filter.keyword"
              :placeholder="use_language.search + ' ' + use_language.store_name + ' / ' + use_language.store_code"
              prepend-inner-icon="mdi-magnify"
              autocomplete="off"
              outlined
              dense
              hide-details
              clearable
              @keyup.enter="search()"
              @click:clear="filter.keyword = null; search()"
            ></v-text-field>
          </v-col>
          <v-col cols="12" md="2" class="pa-1 d-flex align-center">
            <v-spacer/>
            <v-btn :elevation="1" color="primary" class="px-2" @click="search()">{{ use_language.search }}</v-btn>
          </v-col>
        </v-row>

        <!-- PC hidden-xs-only -->
        <v-data-table
          :headers="header"
          :items="items"
          :items-per-page="take"
          hide-default-footer
          :no-data-text="use_language.no_data"
          class="packhai-border-table hidden-xs-only mt-3"
        >
          <template v-slot:item.no="{ item }">{{ (page - 1) * take + items.indexOf(item) + 1 }}</template>
          <template v-slot:item.locationName="{ item }">{{ item.channel }} : {{ item.locationName }}</template>
          <template v-slot:item.contact="{ item }">
            <div>{{ item.contactName }}</div>
            <div style="font-size: 12px; color: #9e9e9e;">{{ item.phone }}</div>
          </template>
          <template v-slot:item.address="{ item }">{{ fullAddress(item) }}</template>
          <template v-slot:item.edit="{ item }">
            <a @click="Edit(item)"><v-icon size="18">fa-edit</v-icon></a>
          </template>
        </v-data-table>

        <!-- Mobile hidden-sm-and-up -->
        <v-data-iterator
          :items="items"
          :items-per-page="take"
          hide-default-footer
          :no-data-text="use_language.no_data"
          class="hidden-sm-and-up mt-3"
        >
          <template v-slot:default="props">
            <v-row>
              <v-col v-for="item in props.items" :key="item.shopCustomerID" cols="12" class="pa-1">
                <v-card>
                  <v-row class="pa-2">
                    <v-col cols="12" class="pa-0"><b>{{ item.storeName }}</b> ({{ item.storeCode }})</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.location }} : {{ item.channel }} : {{ item.locationName }}</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.contact }} : {{ item.contactName }} {{ item.phone }}</v-col>
                    <v-col cols="12" class="pa-0">{{ use_language.address }} : {{ fullAddress(item) }}</v-col>
                    <v-col cols="12" class="pa-0 text-right">
                      <a @click="Edit(item)"><v-icon size="16" class="mr-2">fa-edit</v-icon></a>
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
            </v-row>
          </template>
        </v-data-iterator>

        <div class="pt-3">
          <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="7" @input="Load_data()"></v-pagination>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import Loading from '@/website/components/Loading'
  import OmsImportDialog from '@/website/backend/oms/components/OmsImportDialog'
  import { getOmsLanguage } from '@/website/backend/oms/oms_language'
  import { Trim_value } from '@/website/global_function'
  import { getLocationList, getStoreList, importStore, saveStore, getPostcodeMappingList } from '@/website/backend/oms/oms_service'

  export default {
    components: {
      Loading,
      OmsImportDialog
    },
    data: () => ({
      // page
      page_loading: true,
      loading: false,
      use_language: getOmsLanguage(),
      importDialog: false,

      // popup เพิ่ม/แก้ไข
      dialog: false,
      store: { shopCustomerId: 0 },
      postcodeMapping: [],
      rulesRequired: [],
      rulesPhone: [],

      locations: [],
      filter: { channel: null, locationId: null, keyword: null },
      items: [],
      count: 0,
      page: 1,
      take: 50
    }),
    computed: {
      pageCount () {
        return Math.ceil(this.count / this.take)
      },
      channelItems () {
        return [
          { value: null, text: this.use_language.all },
          { value: 'ON', text: 'ON' },
          { value: 'TT', text: 'TT' }
        ]
      },
      locationItems () {
        return [
          { value: null, text: this.use_language.all_location },
          ...this.locations
            .filter(location => this.filter.channel == null || location.channel == this.filter.channel)
            .map(location => ({ value: location.id, text: location.channel + ' : ' + location.name }))
        ]
      },
      header () {
        return [
          { text: this.use_language.no, align: 'center', value: 'no', sortable: false, width: '70px' },
          { text: this.use_language.store_code, align: 'center', value: 'storeCode', sortable: false, width: '120px' },
          { text: this.use_language.store_name, align: 'left', value: 'storeName', sortable: false },
          { text: this.use_language.location, align: 'left', value: 'locationName', sortable: false, width: '200px' },
          { text: this.use_language.contact, align: 'left', value: 'contact', sortable: false, width: '160px' },
          { text: this.use_language.address, align: 'left', value: 'address', sortable: false },
          { text: this.use_language.edit, align: 'center', value: 'edit', sortable: false, width: '80px' }
        ]
      },
      importColumns () {
        return [
          { key: 'storeCode', header: 'รหัสร้าน', aliases: ['Store Code', 'รหัสร้านค้า'] },
          { key: 'storeName', header: 'ชื่อร้าน', aliases: ['Store Name', 'ชื่อร้านค้า'] },
          { key: 'contactName', header: 'ผู้ติดต่อ', aliases: ['Contact'] },
          { key: 'phone', header: 'เบอร์โทร', aliases: ['Phone', 'โทร'] },
          { key: 'address', header: 'ที่อยู่', aliases: ['Address'] },
          { key: 'subDistrict', header: 'ตำบล/แขวง', aliases: ['ตำบล', 'แขวง', 'SubDistrict'] },
          { key: 'postcode', header: 'รหัสไปรษณีย์', aliases: ['Postcode'] },
          { key: 'channel', header: 'ช่องทาง', aliases: ['Channel'] },
          { key: 'locationName', header: 'Location', aliases: ['Storage Location', 'ชื่อ Location'] }
        ]
      },
      importTemplateRows () {
        return [
          ['ON-000123', 'ร้านตัวอย่าง', 'คุณตัวอย่าง', '0800000000', '99/1 ถนนรัตนาธิเบศร์', 'บางกระสอ', '11000', 'ON', 'จังหวัดนนทบุรี (1)'],
          ['TT-000001', 'เอเย่นต์ตัวอย่าง', 'คุณตัวอย่าง', '0800000001', '1 ถนนพหลโยธิน', 'คลองหนึ่ง', '12120', 'TT', '1017 Pull']
        ]
      }
    },
    async created () {
      document.title = this.$router.history.current.meta.title
      const response = await getLocationList({ isActive: true })
      if (response.status == 'success') {
        this.locations = response.items
      }
      await this.Load_data()
      this.page_loading = false
    },
    methods: {
      Trim_value,
      async Edit (item) {
        this.rulesRequired = []
        this.rulesPhone = []
        if (this.postcodeMapping.length == 0) {
          this.loading = true
          this.postcodeMapping = await getPostcodeMappingList()
          this.loading = false
        }
        if (item != null) {
          this.store = {
            shopCustomerId: item.shopCustomerID,
            locationId: item.locationID,
            storeCode: item.storeCode,
            storeName: item.storeName,
            contactName: item.contactName,
            phone: item.phone,
            address: item.address,
            postcodeMappingId: item.postcodeMappingID
          }
        } else {
          // เพิ่มใหม่: ใช้ location ที่กำลังกรองอยู่เป็นค่าเริ่มต้น
          this.store = {
            shopCustomerId: 0, locationId: this.filter.locationId, storeCode: null, storeName: null, contactName: null,
            phone: null, address: null, postcodeMappingId: null
          }
        }
        this.dialog = true
      },
      async Save () {
        this.rulesRequired = [v => !!v || this.use_language.please_specify]
        this.rulesPhone = [v => !v || String(v).replace(/[^0-9]/g, '').length <= 10 || this.use_language.phone_max_10]
        await this.$nextTick()
        if (!this.$refs.storeForm.validate()) {
          return
        }
        this.loading = true
        const response = await saveStore({
          shopCustomerId: this.store.shopCustomerId,
          locationId: this.store.locationId,
          storeCode: this.store.storeCode,
          storeName: this.store.storeName,
          contactName: this.store.contactName,
          phone: this.store.phone,
          address: this.store.address,
          postcodeMappingId: this.store.postcodeMappingId
        })
        this.loading = false
        if (response.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          return
        }
        await this.Load_data()
        this.$swal({ toast: true, timer: 1500, showConfirmButton: false, position: 'top', type: 'success', title: this.use_language.success })
        this.dialog = false
      },
      fullAddress (item) {
        return [item.address, item.subDistrict, item.district, item.province, item.postcode].filter(text => !!text).join(' ')
      },
      onChannelChange () {
        this.filter.locationId = null
        this.search()
      },
      async search () {
        this.page = 1
        await this.Load_data()
      },
      async Load_data () {
        this.loading = true
        const response = await getStoreList({
          channel: this.filter.channel,
          locationId: this.filter.locationId,
          keyword: this.filter.keyword,
          skip: (this.page - 1) * this.take,
          take: this.take
        })
        this.loading = false
        if (response.status != 'success') {
          this.$swal({
            position: 'top',
            type: 'error',
            text: response.message || (response.errorCode == 'NETWORK' ? this.use_language.network_error : this.use_language.cannot_perform_operation)
          })
          return
        }
        this.items = response.items
        this.count = response.searchResultCount
      },
      // ร้านค้ามีได้หลายพันแถว จึงส่งทีละ 500 แถว แล้วรวมผลและปรับเลขแถวของข้อผิดพลาดให้ตรงกับไฟล์
      async importStoreInChunks (rows) {
        const chunkSize = 500
        const result = { status: 'success', successCount: 0, errors: [] }
        for (let start = 0; start < rows.length; start += chunkSize) {
          const chunk = rows.slice(start, start + chunkSize)
          const response = await importStore(chunk)
          if (response.status != 'success') {
            // ชุดก่อนหน้าบันทึกไปแล้ว จึงรายงานว่าหยุดที่แถวไหน
            result.errors.push({ row: start + 1, message: (response.message || this.use_language.cannot_perform_operation) + ' (' + this.use_language.import_stopped_at_row + ' ' + (start + 2) + ')' })
            break
          }
          result.successCount += response.successCount
          for (const error of response.errors || []) {
            result.errors.push({ row: error.row + start, message: error.message })
          }
        }
        return result
      }
    }
  }
</script>
